<template>
  <div id="home">
    <b-container class="p-0">
      <Title title="Midgrab Savings Calculator" />
      <b-row>
        <b-col id="colHome" class="mr-auto" cols="12">
          <b-img id="bg" :src="require('../assets/images/gunnebo_intro.jpg')" fluid></b-img>
          <div id="content">
            <h2 id="text">Innovative and efficient</h2>
            <h2 id="text">chain shortening</h2>
            <b-button
              id="button"
              class="rounded-pill pl-4 pr-4"
              size="lg"
              to="/calculator"
              href="/calculator"
            >Start saving!</b-button>
          </div>
        </b-col>
      </b-row>
      <Footer />
    </b-container>
  </div>
</template>

<script>
import Title from "./Title.vue";
import Footer from "./Footer.vue";
export default {
  name: "Home",
  components: { Title, Footer }
};
</script>

<style>
#home {
  background-color: #000000;
  overflow: hidden;
}

#content {
  position: absolute;
  top: 35%;
  margin-left: 52%;
}

#text {
  font-size: 2vw;
  color: #ffffff;
}

#button {
  width: 70%;
  height: 20%;

  background-color: #000000;
  font-size: 1.5vw;
  color: #0492c6;

  border-width: 0.1vw;
  border-color: #0492c6;
  margin-top: 5%;
}

@media only screen and (max-width: 1366px) {
  #text {
    font-size: 3vw;
  }
}
@media only screen and (max-width: 576px) {
  #button {
    border-width: 0.2vw;
  }
}
</style>
